import { useState } from 'react';
// import './cadastroPJ.css';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/custom-toast.css';
import Input from '../../../components/form/Input';
import InputCadastro from '../../../components/form/InputCadastro';
import InputCadastroComIcone from '../../../components/form/InputCadastroComIcone';
import InputCelularEstrangeiro from '../../../components/form/InputCelularEstrangeiro';
import InputCnpj from '../../../components/form/InputCnpj';
import InputCpf from '../../../components/form/InputCpf';
import InputRazaoSocial from '../../../components/form/InputRazaoSocial';
import InputSenha from '../../../components/form/InputSenha';
import useFetch from '../../../components/hooks/useFetch';
import { abreAlertaDialog } from '../../../components/modal/AlertaDialog';
import { createFormSchemasPJ } from './FormSchemaPJ';

const FormCadastroPJEstrangeiroComCnpj = ({ onSubmit, data }) => {
  const { t } = useTranslation();
  const { formSchemaPJ } = createFormSchemasPJ(t);
  const methods = useForm({ resolver: yupResolver(formSchemaPJ) });
  const formMethods = {
    inputRef: methods.register,
    errors: methods.errors,
    control: methods.control,
    watch: methods.watch,
  };

  const [ddi, setDdi] = useState();
  const atribuirDDI = (event) => {
    setDdi(event.target.value);
  };

  const { request: requestMeuCorreios, data: dadosCNPJ } = useFetch();
  const { request: requestRFB, data: dadosRFB } = useFetch();
  const [desabilitarCampo, setDesabilitarCampo] = useState(true);
  const [desabilitarSalvar, setDesabilitarSalvar] = useState(true);

  const [radioToken, setRadioToken] = useState('E');
  const [CNPJ, setCNPJ] = useState();
  const handleRadioToken = (event) => {
    setRadioToken(event.target.value);
  };
  const [isCheckedTermo, setIsCheckedTermo] = useState(false);
  const handleTermo = () => {
    setIsCheckedTermo(!isCheckedTermo);
    if (!isCheckedTermo) {
      setDesabilitarSalvar(false);
    } else {
      setDesabilitarSalvar(true);
    }
  };
  const handleReset = () => {
    setDesabilitarCampo(true);
    const form = document.getElementById('FormCadastro');
    const campos = form.querySelectorAll('input, select');
    campos.forEach((campo) => {
      campo.value = '';
    });
  };
  const navigate = useNavigate();
  function handleSubmit(data) {
    if (!isCheckedTermo) {
      abreAlertaDialog(t('cadastro.messages.validation.terms_required'));
    } else {
      const telefoneFormatado = data.foneMovel.replace(/[\(\)\-\s]/g, '');
      const cnpjSemFormatacao = data.cnpj.replace(/[\/.-]/g, '').toUpperCase();
      const cpf = data.cpf.replace(/[.-]/g, '');

      var formattedDate = null;
      if (data.dataNascimento) {
        const dataNasc = new Date(data.dataNascimento);
        const yyyy = dataNasc.getFullYear();
        const mm = String(dataNasc.getMonth() + 1).padStart(2, '0');
        const dd = String(dataNasc.getDate()).padStart(2, '0');
        formattedDate = `${yyyy}-${mm}-${dd}`;
      }


  setCNPJ(data.cnpj.replace(/[\/.-]/g, '').toUpperCase());
      const dadosCompletosPJ = {
        //        cnpj: CNPJ,
        //        idCorreios: CNPJ,
        cnpj: cnpjSemFormatacao,
        idCorreios: cnpjSemFormatacao,
        sediadaForaBrasil: 'S',
        foneMovel: telefoneFormatado,
        dddMovel: data.dddMovel,
        ddiMovel: data.ddiMovel,
        tipo: 'PJ',
        termoAceito: 'S',
        nome: data.nome.trim().toUpperCase(),
        senha: data.senha,
        email: data.email.trim(),
        meioEnvio: data.meioEnvio,
        situacaoAtual: 'P',
        nomeFantasia: data.nomeFantasia.trim().toUpperCase(),
        dataNascRepresentanteLegal: formattedDate,
        cpfRepresentanteLegal: cpf
      };
      onSubmit(dadosCompletosPJ);
    }
  }
  return (
    <>
      <hr />

      <form id="FormCadastro" onSubmit={methods.handleSubmit(handleSubmit)}>
        <InputCnpj
          label={t('cadastro.forms.labels.cnpj')}
          type="text"
          id="cnpj"
          name="cnpj"
          //onBlur={handleCNPJ}
          {...formMethods}
        />
        <InputRazaoSocial
          type="text"
          id="nome"
          name="nome"
          placeholder=""
          label={t('cadastro.forms.labels.company_name')}
          {...formMethods}
        //disabled={desabilitarCampo}
        />
        <InputCadastro
          type="text"
          id="nomeFantasia"
          name="nomeFantasia"
          label={t('cadastro.forms.labels.trade_name')}
          placeholder=""
          {...formMethods}
        //disabled={desabilitarCampo}
        />
        <InputCadastroComIcone
          type="email"
          id="email"
          name="email"
          label={t('cadastro.forms.labels.email')}
          placeholder="email@email.com"
          iconName="ic-carta"
          {...formMethods}
        //disabled={desabilitarCampo}
        />
        <InputCpf
          type="text"
          id="cpf"
          name="cpf"
          placeholder=""
          label={
            <span style={{ whiteSpace: 'pre-line' }}>
              {t('cadastro.forms.labels.cpf_representante_legal')}
            </span>
          }
          {...formMethods}
        />
        <InputCadastro
          className="input-data"
          type="date"
          id="dataNascimento"
          name="dataNascimento"
          label={t('cadastro.forms.labels.nascimento_representante_legal')}
          {...formMethods}
        />
        <div className="container-telefone">
          <InputCadastroComIcone
            type="text"
            className="col-1"
            campoClassName="campo-ddi"
            iconName="ic-adicionar"
            id="ddiMovel"
            name="ddiMovel"
            maxLength="2"
            placeholder="99"
            label={t('cadastro.forms.labels.ddi')}
            {...formMethods}
            onBlur={atribuirDDI}
          //disabled={desabilitarCampo}
          />
          <InputCadastro
            type="text"
            className="col-1"
            campoClassName="campo-ddd"
            id="dddMovel"
            name="dddMovel"
            maxLength="3"
            label={t('cadastro.forms.labels.ddd')}
            placeholder="999"
            {...formMethods}
            onBlur={atribuirDDI}
          //disabled={desabilitarCampo}
          />
          <InputCelularEstrangeiro
            type="tel"
            id="foneMovel"
            name="foneMovel"
            label={t('cadastro.forms.labels.mobile')}
            {...formMethods}
          //disabled={desabilitarCampo}
          />
        </div>
        <InputSenha
          id="senha"
          name="senha"
          label={
            t('cadastro.forms.labels.password') +
            ' ' +
            t('cadastro.messages.validation.password_requirements')
          }
          placeholder=""
          {...formMethods}
        //disabled={desabilitarCampo}
        />
        <InputSenha
          id="confirmaSenha"
          name="confirmaSenha"
          label={t('cadastro.forms.labels.confirm_password')}
          placeholder=""
          {...formMethods}
        //disabled={desabilitarCampo}
        />

        <p className="legenda txt-obrigatorios">
          {t('cadastro.forms.labels.required_fields')}
        </p>

        <hr />

        <div className="receber-token radio-container">
          <p className="">
            {t('cadastro.messages.info.token_registration_method', {
              defaultValue:
                'Como deseja receber o token de confirmação de cadastro?',
            })}
          </p>

          <label className="radio">
            <Input
              type="radio"
              id="E"
              name="meioEnvio"
              value="E"
              checked={radioToken === 'E'}
              onChange={handleRadioToken}
              //disabled={desabilitarCampo}
              {...formMethods}
            />
            <div className="subtitulo-p">
              {t('cadastro.forms.options.email_option')}
            </div>
          </label>

          <label className="radio">
            <Input
              type="radio"
              id="C"
              name="meioEnvio"
              value="C"
              checked={radioToken === 'C'}
              onChange={handleRadioToken}
              //disabled="true"
              //disabled={desabilitarCampo}
              {...formMethods}
            />
            <div className="subtitulo-p">
              {t('cadastro.forms.options.mobile_option')}
            </div>
          </label>
        </div>

        <hr />
        <label className="input-checkbox">
          <Input
            type="checkbox"
            id="termo"
            name="termo"
            checked={isCheckedTermo}
            onChange={handleTermo}
          //disabled={desabilitarCampo}
          />
          <div>
            {t('cadastro.messages.info.privacy_acceptance_read', {
              defaultValue: 'Li e aceito a',
            })}
            &ensp;
            <a
              className="txt-link"
              href="https://www.correios.com.br/falecomoscorreios/politica-de-privacidade-e-notas-legais"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('cadastro.legal.privacy_policy')}
            </a>
          </div>
        </label>
        <br />

        <div className="btns-row">
          <button
            id="btn-prosseguir"
            type="submit"
            className="btn-pre primario"
            disabled={desabilitarSalvar}
          >
            {t('cadastro.forms.buttons.register')}
          </button>
          <button
            id="btn-limpar"
            type="reset"
            className="btn-txt"
            onClick={handleReset}
          //disabled={desabilitarCampo}
          >
            {t('cadastro.forms.buttons.clear')}
          </button>
          <button
            id="btn-voltar"
            type="button"
            className="btn-txt"
            onClick={() => navigate('/login')}
          >
            {t('cadastro.forms.buttons.cancel')}
          </button>
        </div>
      </form>
    </>
  );
};
export default FormCadastroPJEstrangeiroComCnpj;
